import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';

// if (!window.Promise) {
//   window.Promise = Promise;
// }

class LandingPage extends Component {

  constructor(props) {
    super(props)
  }

    render(){
      return (
        <div className="overlay">
            <div className ="bookNowdiv">
              <button className="bookNowButton">Book A Service</button>
            </div>
            <p className="alreadyHaveAccountButton">Already have an Account?</p>
        </div>
      )
    }
}
export default LandingPage;



// WEBPACK FOOTER //
// ./src/Components/LandingPage.js